import { render, staticRenderFns } from "./Clone.vue?vue&type=template&id=65c6b429&"
import script from "./Clone.vue?vue&type=script&lang=js&"
export * from "./Clone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports